<template>
  <div id="recruit" class="con">
    <navheader></navheader>
    <fixheader></fixheader>
    <div class="our_recruit"></div>
    <div class="container" style="max-width: 1024px !important;">
      <el-row :gutter="50">
      </el-row>
      <div class="block">
        <div class="recruit">
          <div class="organ mess">
            <el-link :underline="false">诚聘英才</el-link>
            <p style="font-size: 16x;">国超期待与您的合作</p>
            <p style="font-size: 16x;">共同打造国内领先、国际超前的现代化信息企业</p>
          </div>
          <el-divider class="space"></el-divider>
          <div class="recruit_message" v-for="(item,index) in tableData" :key="index">
            <p v-html="item.content">{{item.content}}</p>
          </div>
        </div>
      </div>
    </div>
    <filing></filing>
  </div>
</template>

<script>
  import navheader from '@/components/Navheader.vue'
  import fixheader from '@/components/Fixheader.vue'
  import filing from '@/components/Filing.vue'
  export default {
    name: 'news',
    components: {
      navheader,
      fixheader,
      filing
    },
    data() {
      return {
        tableData: []
      };
    },
    mounted: function() {
      // this.$router.afterEach((to, from, next) => {
      //   window.scrollTo(0, 0)
      // })
      this.loadContent();
    },
    methods: {
      loadContent() {
        this.axios.get(this.$http + "api/index/getRecruit", {
            params: {}
          })
          .then((res) => {
            this.tableData = res.data.data;
          })
          .catch((err) => {})
      }
    }
  }
</script>

<style>
  .title-color,
  .content-news {
    color: #606266;
  }

  #recruit .recruit .organ {
    margin: 50px 0;
  }

  #recruit div.space {
    height: 3px !important;
    position: relative;
  }

  #recruit div.space:before {
    position: absolute;
    content: "";
    top: 0;
    width: 160px;
    height: 3px;
    background-color: rgba(0, 0, 0, 0.6);
    right: calc(50% - 80px);
  }

  .recruit_message {
    margin-bottom: 30px;
  }

  .recruit_message table {
    width: 100%;
    border-collapse: collapse;
  }

  .recruit_message table td {
    border: 1px solid rgba(0, 0, 0, 0.3) !important;
    min-width: 160px;
    font-size: 14px !important;
    line-height: 3 !important;
    padding: 10px !important;
    color: rgba(0,0,0,0.7) !important;
  }

  .recruit_message table td font,.recruit_message table td font span{
    color: rgba(0,0,0,0.7) !important;
    font-size: 14px !important;
  }
</style>



// WEBPACK FOOTER //
// src/content/Our_recruit.vue